var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "stats"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" ID "), _c('Tooltip', {
    attrs: {
      "content": "Unique Identifier of this transaction"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.tx.hash) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Block "), _c('Tooltip', {
    attrs: {
      "content": "The number of the block in which the transaction was recorded."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('router-link', {
    attrs: {
      "to": "/evmblock/".concat(_vm.tx.block)
    }
  }, [_vm._v(_vm._s(_vm.tx.block))])], 1)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Timestamp "), _c('Tooltip', {
    attrs: {
      "content": "The date and time when this transaction was accepted by the Avalanche Network"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.tx.createdAt) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" From "), _c('Tooltip', {
    attrs: {
      "content": "The sending account of the transaction"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('router-link', {
    attrs: {
      "to": "/evmaddress/".concat(_vm.tx.fromAddr)
    }
  }, [_vm._v(_vm._s(_vm.tx.fromAddr))])], 1)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" To "), _c('Tooltip', {
    attrs: {
      "content": "The receiving account of the transaction (could be a contract address)."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('router-link', {
    attrs: {
      "to": "/evmaddress/".concat(_vm.tx.toAddr)
    }
  }, [_vm._v(_vm._s(_vm.tx.toAddr))])], 1)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Value "), _c('Tooltip', {
    attrs: {
      "content": "The value being transacted in AVAX."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.tx.value) + " " + _vm._s(_vm.nativeSymbol) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Input "), _c('Tooltip', {
    attrs: {
      "content": "Additional information that is required for the transaction."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.tx.input) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Price "), _c('Tooltip', {
    attrs: {
      "content": "Cost per unit of gas specified for the transaction, in AVAX and nAVAX."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.tx.gasPrice) + " " + _vm._s(_vm.nativeSymbol) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Limit "), _c('Tooltip', {
    attrs: {
      "content": "Maximum amount of gas provided for the transaction. For normal AVAX transfers, the value is 21,000. For contract calls, this value is higher and bound by block gas limit."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.tx.gasLimit) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }